module.exports = __webpack_public_path__ + "media/images/admin/icons/tablet-8ddad2ad1d57ec4373c3a4bd7a920761.svg";